import React from 'react'
import { DataGrid } from '@the-platform-group/component-library/DataGrid'
import usePeopleMergeMutation from '../../hooks/usePeopleMergeMutation'
import { getMergeRecordColumns } from './mergeRecordColumns'

const MergeRecordsTable = ({
  records,
  isLoading,
  pagination,
  itemCount,
  onPageChange,
  onPageSizeChange,
}) => {
  const { merge } = usePeopleMergeMutation()

  const handleRetry = ({ sourceId, targetId, jobMappings, jobOverrides }) => {
    merge({ sourceId, targetId, jobMappings, jobOverrides, isRetry: true })
  }

  const columns = getMergeRecordColumns({ onRetry: handleRetry })

  return (
    <DataGrid
      name="peopleMergeRecordsTable"
      columns={columns}
      rows={records}
      loading={isLoading}
      page={pagination.page}
      pageSize={pagination.pageSize}
      rowCount={itemCount}
      pageSizeOptions={[10, 25, 50]}
      onPageChange={onPageChange}
      onPageSizeChange={onPageSizeChange}
      localeText={{ noRowsLabel: 'No Merge Records Found' }}
      getRowHeight={() => 'auto'}
      sx={{
        '& .MuiDataGrid-cell': {
          px: 2,
        },
      }}
    />
  )
}

export default MergeRecordsTable
